import { useContext } from 'react'
import { HoverContext } from '../state/contexts'

export const useContextualHover = () => useContext(HoverContext)
